import React from 'react';

type ProgramLearningContentActionSelectModalProps = {
  open: boolean;
  mode: 'import' | 'export';
  busy?: boolean;
  onClose: () => void;
  onSelectCsv: () => void;
  onSelectWorkspace: () => void;
};

const ProgramLearningContentActionSelectModal: React.FC<ProgramLearningContentActionSelectModalProps> = ({
  open,
  mode,
  busy = false,
  onClose,
  onSelectCsv,
  onSelectWorkspace,
}) => {
  if (!open) return null;

  const title = mode === 'import' ? '학습내용 가져오기 방식 선택' : '학습내용 내보내기 방식 선택';
  const csvLabel = mode === 'import' ? 'CSV 파일\n가져오기' : 'CSV 파일\n내보내기';
  const workspaceLabel =
    mode === 'import' ? '기본 학습내용\n데이터 가져오기' : '기본 학습내용으로\n데이터 내보내기';

  return (
    <div
      className="cp-modal-backdrop"
      role="presentation"
      data-tutorial-learning-action-select={mode}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !busy) onClose();
      }}
    >
      <div
        className="cp-modal cp-program-page-split-modal cp-program-learning-action-select-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-program-learning-action-select-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <h3 id="cp-program-learning-action-select-title">{title}</h3>
        <div className="cp-modal-body">
          <p>원하는 처리 방식을 선택해 주세요.</p>
        </div>
        <div className="cp-modal-footer">
          <button
            type="button"
            className="cp-btn-secondary"
            data-tutorial-learning-action="cancel"
            disabled={busy}
            onClick={onClose}
          >
            취소
          </button>
          <button
            type="button"
            className="cp-btn-secondary"
            data-tutorial-learning-action="csv"
            disabled={busy}
            onClick={onSelectCsv}
          >
            {csvLabel}
          </button>
          <button
            type="button"
            className="cp-btn-primary"
            data-tutorial-learning-action="workspace"
            disabled={busy}
            onClick={onSelectWorkspace}
          >
            {workspaceLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProgramLearningContentActionSelectModal;
